import intl from "react-intl-universal";
import { TbChevronRight } from "react-icons/tb";

const statusStyles = {
  ACTIVE: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400",
  PENDING: "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400",
  BLOCKED: "bg-rose-50 text-rose-700 dark:bg-rose-950/40 dark:text-rose-400",
  CLOSED: "bg-gray-100 text-gray-600 dark:bg-brand-dark-elevated dark:text-gray-400",
};

const formatCreditLimit = (creditInfo) => {
  const limit = creditInfo?.creditLimit;
  if (!limit) return "—";
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: limit.currency || "BRL",
    maximumFractionDigits: 0,
  }).format(limit.amount);
};

const MetricCell = ({ label, value, subValue }) => (
  <div className="min-w-0">
    <p className="text-[10px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
      {label}
    </p>
    <p className="mt-0.5 truncate text-sm font-semibold text-brand-dark dark:text-gray-100">
      {value}
    </p>
    {subValue ? (
      <p className="mt-0.5 truncate text-xs text-gray-500 dark:text-gray-400">{subValue}</p>
    ) : null}
  </div>
);

export const BaasCardAccountCard = ({ account, onSelect }) => {
  const status = account.status || "PENDING";
  const statusLabel =
    intl.get(`baas.cartoes.accounts.status.${status}`) || status;

  return (
    <button
      type="button"
      onClick={() => onSelect(account)}
      className="group flex w-full flex-col rounded-xl border border-gray-200 bg-white text-left transition duration-200 hover:border-gray-300 hover:shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-300 dark:border-brand-dark-border dark:bg-brand-dark-surface dark:hover:border-gray-600 dark:focus-visible:ring-gray-600"
    >
      <div className="flex items-start justify-between gap-3 border-b border-gray-100 px-4 py-3.5 dark:border-brand-dark-border">
        <div className="min-w-0">
          <p className="truncate text-base font-bold text-brand-dark dark:text-gray-100">
            {account.personName || account.personId || account.id}
          </p>
          <div className="mt-1.5 flex flex-wrap items-center gap-2">
            <span
              className={`inline-flex items-center rounded-md px-2 py-0.5 text-[10px] font-semibold ${statusStyles[status] ?? statusStyles.PENDING}`}
            >
              {statusLabel}
            </span>
            {account.psProductCode ? (
              <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-600 dark:bg-brand-dark-elevated dark:text-gray-400">
                {account.psProductCode}
              </span>
            ) : null}
          </div>
        </div>
        <TbChevronRight className="mt-0.5 h-5 w-5 shrink-0 text-gray-300 transition group-hover:text-gray-500 dark:text-gray-600 dark:group-hover:text-gray-400" />
      </div>

      <div className="grid grid-cols-2 gap-x-4 gap-y-3 px-4 py-3.5 sm:grid-cols-4">
        <MetricCell
          label={intl.get("baas.cartoes.accounts.columns.program")}
          value={account.cardProgramName || "—"}
          subValue={account.product?.name || account.psProductCode || null}
        />
        <MetricCell
          label={intl.get("baas.cartoes.accounts.columns.creditLimit")}
          value={formatCreditLimit(account.creditInfo)}
        />
        <MetricCell
          label={intl.get("baas.cartoes.accounts.columns.linkedAccount")}
          value={account.accountId || intl.get("baas.cartoes.accounts.notLinked")}
        />
        <MetricCell
          label={intl.get("baas.cartoes.accounts.columns.id")}
          value={account.id}
        />
      </div>
    </button>
  );
};
